import styled from 'styled-components';

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

export const Container = styled.div`
  flex-grow: 1;
  display: flex;
  width: 100%;

  @media (width <= 1023px) {
    flex-direction: column;
    align-items: center;
    max-width: 350px;
  }

  @media (width >= 1024px) {
    justify-content: center;
    column-gap: 48px;
  }
`;

export const Column = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 350px;
`;

export const Image = styled.img`
  width: 100%;
  height: auto;
  object-fit: contain;

  @media (width <= 1023px) {
    display: none;
  }
`;

export const Subtitle = styled.div`
  @media (max-width: 1023px) {
    display: none;
  }

  @media (min-width: 1024px) {
    margin-bottom: 80px;
  }
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  row-gap: 44px;
  width: 100%;
`;

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: #dcdfe9;
`;

export const DistributorContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 20px;
`;

export const DistributorList = styled.ul`
  display: flex;
  flex-direction: column;
  row-gap: 8px;
  list-style: none;
`;

export const DistributorHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`;

export const DistributorTitle = styled.div`
  font-size: 13px;
  font-weight: 500;
`;

export const DistributorTooltip = styled.div`
  display: flex;
  margin-left: 4px;
  color: #8f95a5;
  font-size: 17px;
`;

export const DistributorRemoveButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 24px;
  height: 24px;
  font-size: 20px;
`;

export const LoadingContainer = styled.div`
  position: relative;
  width: 100%;

  @media (max-width: 1023px) {
    height: 480px;
  }

  @media (min-width: 1024px) {
    height: 640px;
  }
`;

export const ActiveFilters = styled.span`
  @media (max-width: 1023px) {
    display: none;
  }

  @media (min-width: 1024px) {
    margin-left: 24px;
  }
`;

export const SuccessContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 380px;
  text-align: center;
`;

export const Note = styled.p`
  margin: 8px 0 16px;
  font-size: 13px;
  font-weight: 500;
  line-height: 1.38;
  letter-spacing: 0.13px;
`;

export const TableScrollContainer = styled.div`
  display: flex;
  width: 100%;
  overflow-x: auto;

  @media (max-width: 1023px) {
    padding-left: 16px;
  }

  @media (min-width: 1024px) {
    justify-content: center;
    padding: 0 24px;
  }
`;

export const Table = styled.table`
  flex-shrink: 0;
  max-width: 1304px;

  thead > tr {
    background-color: #f5f4f8;
  }

  thead > tr > th {
    height: 64px;
    padding: 0 24px;

    &:last-child {
      text-align: right;

      & > div {
        justify-content: flex-end;
      }
    }
  }

  tbody > tr > td {
    height: 80px;
    padding: 0 24px;
    border-bottom: 1px solid #dcdfe9;

    &:last-child {
      text-align: right;
    }
  }
`;
